// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=Outfit:wght@300;400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════════════════
   Google Fonts Import
   ═══════════════════════════════════════════════════════════ */

/* ═══════════════════════════════════════════════════════════
   Global Reset & Design Tokens
   ═══════════════════════════════════════════════════════════ */
*,
*::before,
*::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

:root {
  /* ── Color Palette (Obsidian & Emerald) ────────────────── */
  --bg-primary: #080c14;
  --bg-secondary: #0c1220;
  --bg-card: rgba(15, 23, 42, 0.45);
  --bg-sidebar: #090e1a;
  --bg-glass: rgba(255, 255, 255, 0.02);
  --bg-glass-hover: rgba(255, 255, 255, 0.05);

  --text-primary: #f8fafc;
  --text-secondary: #94a3b8;
  --text-muted: #64748b;

  --accent-emerald: #10b981;
  --accent-emerald-hover: #059669;
  --accent-emerald-glow: rgba(16, 185, 129, 0.12);

  --accent-blue: #3b82f6;
  --accent-purple: #8b5cf6;
  --accent-cyan: #06b6d4;
  --accent-rose: #ef4444;

  --border-subtle: rgba(255, 255, 255, 0.04);
  --border-active: rgba(16, 185, 129, 0.35);

  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.5);
  --shadow-md: 0 4px 16px rgba(0, 0, 0, 0.6);
  --shadow-lg: 0 10px 40px rgba(0, 0, 0, 0.8);
  --shadow-emerald: 0 0 25px rgba(16, 185, 129, 0.2);

  --radius-sm: 8px;
  --radius-md: 12px;
  --radius-lg: 16px;
  --radius-xl: 24px;

  --font-family: "Outfit", "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  --font-sans: "Inter", sans-serif;
}

[data-theme="light"] {
  --bg-primary: #f8fafc;
  --bg-secondary: #f1f5f9;
  --bg-card: rgba(255, 255, 255, 0.8);
  --bg-sidebar: #ffffff;
  --bg-glass: rgba(0, 0, 0, 0.02);
  --bg-glass-hover: rgba(0, 0, 0, 0.05);

  --text-primary: #0f172a;
  --text-secondary: #475569;
  --text-muted: #64748b;

  --accent-emerald: #10b981;
  --accent-emerald-hover: #059669;
  --accent-emerald-glow: rgba(16, 185, 129, 0.15);

  --accent-blue: #3b82f6;
  --accent-purple: #8b5cf6;
  --accent-cyan: #06b6d4;
  --accent-rose: #ef4444;

  --border-subtle: rgba(0, 0, 0, 0.08);
  --border-active: rgba(16, 185, 129, 0.35);

  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 16px rgba(0, 0, 0, 0.08);
  --shadow-lg: 0 10px 40px rgba(0, 0, 0, 0.12);
  --shadow-emerald: 0 0 25px rgba(16, 185, 129, 0.15);
}

html {
  scroll-behavior: smooth;
}

body {
  font-family: var(--font-family);
  background: var(--bg-primary);
  color: var(--text-primary);
  min-height: 100vh;
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden;
}

a {
  color: inherit;
  text-decoration: none;
}

button {
  font-family: inherit;
  cursor: pointer;
  border: none;
  outline: none;
  background: none;
  color: inherit;
}

/* ═══════════════════════════════════════════════════════════
   Glassmorphism Styles
   ═══════════════════════════════════════════════════════════ */
.glass-card {
  background: var(--bg-card);
  backdrop-filter: blur(25px);
  -webkit-backdrop-filter: blur(25px);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

.glass-card:hover {
  border-color: rgba(255, 255, 255, 0.08);
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

/* ═══════════════════════════════════════════════════════════
   Background Ambient Glowing mesh
   ═══════════════════════════════════════════════════════════ */
.bg-mesh {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  pointer-events: none;
  background:
    radial-gradient(ellipse 70% 50% at 10% 20%, rgba(16, 185, 129, 0.05), transparent),
    radial-gradient(ellipse 60% 40% at 85% 15%, rgba(16, 185, 129, 0.04), transparent),
    radial-gradient(ellipse 50% 60% at 50% 85%, rgba(139, 92, 246, 0.03), transparent);
}

/* ═══════════════════════════════════════════════════════════
   Scrollbars
   ═══════════════════════════════════════════════════════════ */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: var(--text-muted);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--text-secondary);
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;gEAEgE;;AAGhE;;gEAEgE;AAChE;;;EAGE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,uBAAuB;EACvB,iCAAiC;EACjC,qBAAqB;EACrB,qCAAqC;EACrC,2CAA2C;;EAE3C,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;;EAErB,yBAAyB;EACzB,+BAA+B;EAC/B,+CAA+C;;EAE/C,sBAAsB;EACtB,wBAAwB;EACxB,sBAAsB;EACtB,sBAAsB;;EAEtB,0CAA0C;EAC1C,yCAAyC;;EAEzC,yCAAyC;EACzC,0CAA0C;EAC1C,2CAA2C;EAC3C,kDAAkD;;EAElD,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;;EAEjB,2FAA2F;EAC3F,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,mCAAmC;EACnC,qBAAqB;EACrB,+BAA+B;EAC/B,qCAAqC;;EAErC,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;;EAErB,yBAAyB;EACzB,+BAA+B;EAC/B,+CAA+C;;EAE/C,sBAAsB;EACtB,wBAAwB;EACxB,sBAAsB;EACtB,sBAAsB;;EAEtB,oCAAoC;EACpC,yCAAyC;;EAEzC,0CAA0C;EAC1C,2CAA2C;EAC3C,4CAA4C;EAC5C,mDAAmD;AACrD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;gEAEgE;AAChE;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,mCAAmC;EACnC,sCAAsC;EACtC,+BAA+B;EAC/B,4BAA4B;EAC5B,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;EACvC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;;gEAEgE;AAChE;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB;;;sFAGoF;AACtF;;AAEA;;gEAEgE;AAChE;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC","sourcesContent":["/* ═══════════════════════════════════════════════════════════\n   Google Fonts Import\n   ═══════════════════════════════════════════════════════════ */\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=Outfit:wght@300;400;500;600;700;800&display=swap');\n\n/* ═══════════════════════════════════════════════════════════\n   Global Reset & Design Tokens\n   ═══════════════════════════════════════════════════════════ */\n*,\n*::before,\n*::after {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n:root {\n  /* ── Color Palette (Obsidian & Emerald) ────────────────── */\n  --bg-primary: #080c14;\n  --bg-secondary: #0c1220;\n  --bg-card: rgba(15, 23, 42, 0.45);\n  --bg-sidebar: #090e1a;\n  --bg-glass: rgba(255, 255, 255, 0.02);\n  --bg-glass-hover: rgba(255, 255, 255, 0.05);\n\n  --text-primary: #f8fafc;\n  --text-secondary: #94a3b8;\n  --text-muted: #64748b;\n\n  --accent-emerald: #10b981;\n  --accent-emerald-hover: #059669;\n  --accent-emerald-glow: rgba(16, 185, 129, 0.12);\n\n  --accent-blue: #3b82f6;\n  --accent-purple: #8b5cf6;\n  --accent-cyan: #06b6d4;\n  --accent-rose: #ef4444;\n\n  --border-subtle: rgba(255, 255, 255, 0.04);\n  --border-active: rgba(16, 185, 129, 0.35);\n\n  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.5);\n  --shadow-md: 0 4px 16px rgba(0, 0, 0, 0.6);\n  --shadow-lg: 0 10px 40px rgba(0, 0, 0, 0.8);\n  --shadow-emerald: 0 0 25px rgba(16, 185, 129, 0.2);\n\n  --radius-sm: 8px;\n  --radius-md: 12px;\n  --radius-lg: 16px;\n  --radius-xl: 24px;\n\n  --font-family: \"Outfit\", \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n  --font-sans: \"Inter\", sans-serif;\n}\n\n[data-theme=\"light\"] {\n  --bg-primary: #f8fafc;\n  --bg-secondary: #f1f5f9;\n  --bg-card: rgba(255, 255, 255, 0.8);\n  --bg-sidebar: #ffffff;\n  --bg-glass: rgba(0, 0, 0, 0.02);\n  --bg-glass-hover: rgba(0, 0, 0, 0.05);\n\n  --text-primary: #0f172a;\n  --text-secondary: #475569;\n  --text-muted: #64748b;\n\n  --accent-emerald: #10b981;\n  --accent-emerald-hover: #059669;\n  --accent-emerald-glow: rgba(16, 185, 129, 0.15);\n\n  --accent-blue: #3b82f6;\n  --accent-purple: #8b5cf6;\n  --accent-cyan: #06b6d4;\n  --accent-rose: #ef4444;\n\n  --border-subtle: rgba(0, 0, 0, 0.08);\n  --border-active: rgba(16, 185, 129, 0.35);\n\n  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.05);\n  --shadow-md: 0 4px 16px rgba(0, 0, 0, 0.08);\n  --shadow-lg: 0 10px 40px rgba(0, 0, 0, 0.12);\n  --shadow-emerald: 0 0 25px rgba(16, 185, 129, 0.15);\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nbody {\n  font-family: var(--font-family);\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  min-height: 100vh;\n  line-height: 1.5;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  overflow-x: hidden;\n}\n\na {\n  color: inherit;\n  text-decoration: none;\n}\n\nbutton {\n  font-family: inherit;\n  cursor: pointer;\n  border: none;\n  outline: none;\n  background: none;\n  color: inherit;\n}\n\n/* ═══════════════════════════════════════════════════════════\n   Glassmorphism Styles\n   ═══════════════════════════════════════════════════════════ */\n.glass-card {\n  background: var(--bg-card);\n  backdrop-filter: blur(25px);\n  -webkit-backdrop-filter: blur(25px);\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-md);\n  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.glass-card:hover {\n  border-color: rgba(255, 255, 255, 0.08);\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-lg);\n}\n\n/* ═══════════════════════════════════════════════════════════\n   Background Ambient Glowing mesh\n   ═══════════════════════════════════════════════════════════ */\n.bg-mesh {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 0;\n  pointer-events: none;\n  background:\n    radial-gradient(ellipse 70% 50% at 10% 20%, rgba(16, 185, 129, 0.05), transparent),\n    radial-gradient(ellipse 60% 40% at 85% 15%, rgba(16, 185, 129, 0.04), transparent),\n    radial-gradient(ellipse 50% 60% at 50% 85%, rgba(139, 92, 246, 0.03), transparent);\n}\n\n/* ═══════════════════════════════════════════════════════════\n   Scrollbars\n   ═══════════════════════════════════════════════════════════ */\n::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--text-muted);\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: var(--text-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
